


































































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import UsedCapacity from '@/components/storage/drawers/directoryListNavigationDrawer/UsedCapacity.vue';
import { vxm } from '@/store';
import { FindDirectoriesAndFilesQueryDto, FindDirectoryDetail, FindDirectoryFileDetail } from '@/@types/Directory';

@Component({
  components: {
    UsedCapacity,
  },
})
export default class DirectoryListNavigationDrawer extends Vue {
  @Prop({ required: true })
  private projectId!: number;
  private directories: FindDirectoryDetail[] = [];
  private files: FindDirectoryFileDetail[] = [];
  private drawer: boolean = true;
  private mini: boolean = false;
  private caseSensitive: boolean = false;
  private openDirectory: Array<number> = [];
  private openFile: Array<number> = [];
  private searchWord = '';
  private closeOnClick: boolean = true;
  private menuItems = [
    { title: '削除' },
  ];

  private async created() {
    if (!vxm.theoryApi.directoriesStore.getCurrentDirectoryAndFiles) {
      const query: FindDirectoriesAndFilesQueryDto = {
        'project-id': this.projectId,
        'order': 'asc',
      };
      await Promise.all([
        vxm.theoryApi.directoriesStore.fetchDirectoriesAndFiles(query),
        vxm.theoryApi.directoriesStore.fetchCurrentDirectoryAndFiles(query),
      ]);
    }
    this.directories = vxm.theoryApi.directoriesStore.getCurrentDirectoryAndFiles?.results.directories ?? [];
    this.files = vxm.theoryApi.directoriesStore.getCurrentDirectoryAndFiles?.results.files ?? [];
  }

  private async onDirectoryEvent(menuTitle: string, directoryId: number) {
    if (menuTitle === '削除') {
      await this.deleteDirectory(directoryId);
    }
  }

  private async onFileEvent(menuTitle: string, fileId: number) {
    if (menuTitle === '削除') {
      await this.deleteFile(fileId);
    }
  }

  private async deleteDirectory(directoryId: number) {
    await vxm.theoryApi.directoriesStore.deleteDirectory({
      directoryId: directoryId,
      projectId: this.projectId,
    });
  }

  private async deleteFile(fileId: number) {
    await vxm.theoryApi.filesStore.deleteFile({ fileId: fileId, projectId: this.projectId });
  }

  private selectedDirectoryPutArray(id: number) {
    if (this.openDirectory.includes(id)) {
      this.openDirectory.splice(this.openDirectory.indexOf(id), 1);
    } else {
      this.openDirectory.push(id);
    }
  }

  private selectedFilePutArray(id: number) {
    if (this.openFile.includes(id)) {
      this.openFile.splice(this.openFile.indexOf(id), 1);
    } else {
      this.openFile.push(id);
    }
  }

  /**フォルダ２階層分取得するようあとで追加修正（メモ） */
  private async fetchCurrentDirectoryAndFiles(selectedDirectory: FindDirectoryDetail) {
    const directoryId = selectedDirectory.directoryId;
    const query: FindDirectoriesAndFilesQueryDto = {
      'project-id': this.projectId,
      'parent-directory-id': directoryId,
      'order': 'asc',
    };
    await vxm.theoryApi.directoriesStore.fetchCurrentDirectoryAndFiles(query);
    const currentDirectories = vxm.theoryApi.directoriesStore.getCurrentDirectoryAndFiles?.results.directories;

    if (currentDirectories?.length) {
      const recursiveSearch = (childDir: FindDirectoryDetail) => {
        // 自分を処理
        if (childDir.directoryId === selectedDirectory.directoryId) {
          this.$set(childDir, 'directories', currentDirectories);
          return;
        }
        if (childDir.directories) {
          childDir.directories.forEach((gChildDir) => {
            recursiveSearch(gChildDir);
          });
        }
      }

      this.directories.forEach((rootDir, index) => {
        recursiveSearch(rootDir);
        this.directories[index] = rootDir;
      });
    }

    vxm.theoryApi.directoriesStore.fetchCurrentDirectory(selectedDirectory);
  }

  private async onUpDirectory() {
    const currentDirectory = vxm.theoryApi.directoriesStore.getCurrentDirectory;
    if (currentDirectory) {
      /** カレントディレクトリの親ディレクトリが無い場合、カレントディレクトリをnullで更新する
       * 存在する場合、その親ディレクトリでカレントディレクトリを更新する
       */
      if (currentDirectory.parentDirectoryId) {
        await vxm.theoryApi.directoriesStore.fetchParentDirectory({
          directoryId: currentDirectory.parentDirectoryId as number,
          query: { 'project-id': this.projectId },
        });
        const parentDirectory = vxm.theoryApi.directoriesStore.getParentDirectory;
        if (parentDirectory) {
          vxm.theoryApi.directoriesStore.fetchCurrentDirectory(parentDirectory.results);
        }
      } else {
        vxm.theoryApi.directoriesStore.fetchCurrentDirectory(null);
        vxm.theoryApi.directoriesStore.fetchParentDirectory(null);
      }
      const fetchDirectoriesAndFilesQuery = {
        'project-id': this.projectId,
        'parent-directory-id': this.currentDirectoryId,
        'order': 'asc',
      };
      await vxm.theoryApi.directoriesStore.fetchDirectoriesAndFiles(fetchDirectoriesAndFilesQuery);
    }
  }

  private get getDirectories() {
    const directories = vxm.theoryApi.directoriesStore.getDirectoriesAndFiles?.results.directories ?? [];
    this.directories = this.searchWord ? directories.filter((d) => d.directoryName.includes(this.searchWord)) : directories;
    return directories;
  }

  private get getFiles() {
    const files = vxm.theoryApi.directoriesStore.getDirectoriesAndFiles?.results.files ?? [];
    this.files = this.searchWord ? files.filter((f) => f.fileName.includes(this.searchWord)) : files;
    return files;
  }

  private get currentDirectoryId() {
    const response = vxm.theoryApi.directoriesStore.getCurrentDirectory;
    if (response) {
      return response.directoryId;
    } else return null;
  }

  private get parentDirectoryId() {
    const response = vxm.theoryApi.directoriesStore.getParentDirectory;
    if (response) {
      return response.results.parentDirectoryId;
    } else return null;
  }
}
